import { render, staticRenderFns } from "./MReview.vue?vue&type=template&id=4ece5428&scoped=true&lang=html&"
import script from "./MReview.vue?vue&type=script&lang=js&"
export * from "./MReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece5428",
  null
  
)

export default component.exports